import { combineReducers } from 'redux';
import getApiReducer from '../../../../common/utils/getApiReducer';
import { GET_GOLF_SCHOOLS, REGISTER_FOR_CLASS } from './actions';

export default combineReducers({
  classRegistration: getApiReducer(REGISTER_FOR_CLASS),
  schools: getApiReducer(GET_GOLF_SCHOOLS),
});



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/redux/reducers.js